import {api} from 'services/api';
import {ResponseData} from 'types/response-data';
import queryParams from 'utils/query-params';

const getOverpaymentsExport = api.injectEndpoints({
  endpoints: builder => ({
    getOverpaymentsExport: builder.query<Response, Request>({
      query: params => {
        return {
          method: 'GET',
          url: `export/overpayments`,
          params: queryParams(params, '|'),
        };
      },
    }),
  }),
});

type Request = {};

type Response = ResponseData<{message: string}>;

export const {useLazyGetOverpaymentsExportQuery} = getOverpaymentsExport;
